import { StreamData } from 'types/streamData'
import { getDisplayHierarchies } from 'utils/geoInfoUtil'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorGeoHighGenealogyResolver: FieldResolver = (metadata: Metadata) =>
  ({
    authorGeoHighGenealogy: getDisplayHierarchies(metadata.getAuthorGeoInfos())
  } as StreamData)

export default authorGeoHighGenealogyResolver
